import CampaignEmployeesModel from './CampaignEmployeesModel'

export default class CampaignModel {
  constructor (data) {
    this.id = data.id
    this.name = data.name
    this.validFrom = data.validFrom
    this.validTo = data.validTo
    this.active = data.active

    this.completedCodes = data.completedCodes
    this.createInProgress = data.createInProgress
    this.sendInProgress = data.sendInProgress
    this.sentEmails = data.sentEmails
    this.started = data.started
    this.totalCodes = data.totalCodes
    this.totalEmails = data.totalEmails

    this.codes = data.codes.map((item) => {
      return new CampaignEmployeesModel(item)
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/extra-campaigns/CampaignModel.js